import Box from "@mui/material/Box";
import React from "react";
import {useTheme} from "../../../contexts/theme";

export default function CustomDivider(){
    const theme = useTheme();

    return (
        <Box
            sx={{
                flexGrow: 1,
                height: '1px',
                borderBottom: `${theme.border.width.thin} ${theme.border.type.solid} ${theme.palette.white}`,
                mx: theme.spacing.sm,
            }}
        />
    )
}